/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Admin_Commission_Attribution_ActiveInputs */



/**
* | output |
* | --- |
* | "Window active" |
*
* @param {Partner_Admin_Commission_Attribution_ActiveInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_admin_commission_attribution_active = /** @type {((inputs?: Partner_Admin_Commission_Attribution_ActiveInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Admin_Commission_Attribution_ActiveInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Zeitraum aktiv")
	return /** @type {LocalizedString} */ ("Window active")
});